// src/features/orders/components/OrderList.tsx
import type { Order } from '../types/orders.types';
import { OrderRow } from './OrderRow';

interface OrderListProps {
  orders: Order[];
  /** id of the order currently open in the Order Workspace, if any */
  selectedOrderId?: string | null;
  /** called when a row is chosen to open the Order Workspace */
  onSelectOrder?: ((order: Order) => void) | undefined;
}

export function OrderList({ orders, selectedOrderId = null, onSelectOrder }: OrderListProps) {
  return (
    <div className="flex flex-col gap-1.5 p-2.5">
      {orders.map((order) => (
        <OrderRow
          key={order.id}
          order={order}
          isSelected={order.id === selectedOrderId}
          onSelect={onSelectOrder}
        />
      ))}
    </div>
  );
}
